export const DESKTOP_APP_DOWNLOAD_URL = "https://releases.gitpod.io/desktop/stable/Ona.dmg";
